module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/2_f24b6524fa141808f648c734faacaf2e.png";